import { IOrderFlexibleColumns } from '../../../../components/reusable/Table/types';
import { TFunction } from 'i18next';

export enum TABLE_COLUMNS_IDS {
  PROVIDER = 'provider',
  ENTITY = 'entity',
  SOURCE_PATH = 'sourcePath',
  DEFAULT_VALUE = 'defaultValue',
  LOCAL_PATH = 'localPath',
  PREFIX = 'prefix',
  TRANSFORM = 'transform',
  ACTIONS = 'ACTIONS',
}

const defaultOrderBy = TABLE_COLUMNS_IDS.PROVIDER;

function _getTableColumns(t: TFunction): IOrderFlexibleColumns[] {
  return [
    {
      id: TABLE_COLUMNS_IDS.PROVIDER,
      label: t('adminDashboard.sync.provider'),
      key: TABLE_COLUMNS_IDS.PROVIDER,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.PROVIDER,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.ENTITY,
      label: 'Entity',
      key: TABLE_COLUMNS_IDS.ENTITY,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.ENTITY,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.SOURCE_PATH,
      label: 'Source path',
      key: TABLE_COLUMNS_IDS.SOURCE_PATH,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.SOURCE_PATH,
      align: 'left',
      hided: false,
      canHide: true,
    },
    {
      id: TABLE_COLUMNS_IDS.LOCAL_PATH,
      label: 'Local path',
      key: TABLE_COLUMNS_IDS.LOCAL_PATH,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.LOCAL_PATH,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.DEFAULT_VALUE,
      label: 'Default value',
      key: TABLE_COLUMNS_IDS.DEFAULT_VALUE,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.DEFAULT_VALUE,
      align: 'left',
      hided: false,
      canHide: true,
    },
    {
      id: TABLE_COLUMNS_IDS.PREFIX,
      label: 'Prefix',
      key: TABLE_COLUMNS_IDS.PREFIX,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.PREFIX,
      align: 'left',
      hided: false,
      canHide: true,
    },
    {
      id: TABLE_COLUMNS_IDS.TRANSFORM,
      label: 'Transform',
      key: TABLE_COLUMNS_IDS.TRANSFORM,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.TRANSFORM,
      align: 'left',
      hided: false,
      canHide: true,
    },
    {
      id: TABLE_COLUMNS_IDS.ACTIONS,
      key: TABLE_COLUMNS_IDS.ACTIONS,
      type: 'string',
      sortable: false,
      sortingKey: TABLE_COLUMNS_IDS.ACTIONS,
      align: 'left',
      hided: false,
      isFixed: true,
      canHide: false,
    },
  ];
}

const getTableColumns = (t: TFunction) => _getTableColumns(t);

const hidedColumns: string[] = [];

export const getDefaultSettings = (t: TFunction) => ({
  columnsOrderIds: Object.keys(_getTableColumns(t)).filter(
    (columnId) => !hidedColumns.includes(columnId),
  ),
  orderBy: defaultOrderBy,
  order: 'asc',
  hidedColumns,
});

export default getTableColumns;
